
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskTemplateModel } from './Entities.GormCrm.TaskTemplate';
import { TaskAreaModel } from './Entities.GormCrm.TaskArea';
import { TaskAttachmentModel } from './Entities.GormCrm.TaskAttachment';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { TaskActionType } from 'enums/TaskActionType';
import { Model, ModelProperty } from 'models/Model';


export class TaskActionModel extends Model<TaskActionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'taskAction.property.id', isHidden: true },
		{ name: 'taskflowId', type: 'guid', languageString: 'taskAction.property.taskflowId' },
		{ name: 'sourceTemplateId', type: 'guid', languageString: 'taskAction.property.sourceTemplateId' },
		{ name: 'details', type: 'string', languageString: 'taskAction.property.details' },
		{ name: 'assignedToUserId', type: 'guid', languageString: 'taskAction.property.assignedToUserId' },
		{ name: 'created', type: 'Date', languageString: 'taskAction.property.created', isHidden: true },
		{ name: 'completed', type: 'Date', languageString: 'taskAction.property.completed' },
		{ name: 'plannedDate', type: 'Date', languageString: 'taskAction.property.plannedDate' },
		{ name: 'dateOnly', type: 'boolean', languageString: 'taskAction.property.dateOnly' },
		{ name: 'taskAreaId', type: 'guid', languageString: 'taskAction.property.taskAreaId' },
		{ name: 'additionalData', type: 'string', languageString: 'taskAction.property.additionalData' },
		{ name: 'step', type: 'number', languageString: 'taskAction.property.step' },
		{ name: 'trackingId', type: 'string', languageString: 'taskAction.property.trackingId' },
		{ name: 'createdById', type: 'guid', languageString: 'taskAction.property.createdById' },
		{ name: 'canceled', type: 'boolean', languageString: 'taskAction.property.canceled' },
		{ name: 'sourceTemplate', type: 'TaskTemplateModel', languageString: 'taskAction.property.sourceTemplate', isHidden: true, isObject: true, new: () => { return new TaskTemplateModel }, properties: () => { return TaskTemplateModel.classProperties } },
		{ name: 'taskArea', type: 'TaskAreaModel', languageString: 'taskAction.property.taskArea', isHidden: true, isObject: true, new: () => { return new TaskAreaModel }, properties: () => { return TaskAreaModel.classProperties } },
		{ name: 'taskAttachments', type: 'TaskAttachmentModel[]', languageString: 'taskAction.property.taskAttachments', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskAttachmentModel }, properties: () => { return TaskAttachmentModel.classProperties } },
		{ name: 'taskflow', type: 'TaskflowModel', languageString: 'taskAction.property.taskflow', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } },
		{ name: 'type', type: 'TaskActionType', languageString: 'taskAction.property.type' }
	];
	[key: string]: any;
	
	public id?: string;
	public taskflowId?: string;
	public sourceTemplateId?: string;
	public details: string;
	public assignedToUserId?: string;
	public created?: Date;
	public completed?: Date;
	public plannedDate?: Date;
	public dateOnly: boolean;
	public taskAreaId?: string;
	public additionalData: string;
	public step: number;
	public trackingId: string;
	public createdById?: string;
	public canceled: boolean;
	public sourceTemplate?: TaskTemplateModel;
	public taskArea?: TaskAreaModel;
	public taskAttachments: TaskAttachmentModel[];
	public taskflow?: TaskflowModel;
	public type: TaskActionType;
    
	constructor(){
		super();
		this.id = undefined;
		this.taskflowId = undefined;
		this.sourceTemplateId = undefined;
		this.details = '';
		this.assignedToUserId = undefined;
		this.created = undefined;
		this.completed = undefined;
		this.plannedDate = undefined;
		this.dateOnly = false;
		this.taskAreaId = undefined;
		this.additionalData = '';
		this.step = 0;
		this.trackingId = '';
		this.createdById = undefined;
		this.canceled = false;
		this.sourceTemplate = undefined;
		this.taskArea = undefined;
		this.taskAttachments = [];
		this.taskflow = undefined;
		this.type = 0;
		
	}
	getProperties(){
		return TaskActionModel.classProperties;
	}
}

